import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Product } from 'src/api/@generated/backend';

import { createOrderActionCreator } from './action-creators/create-order-action-creator';
import { OrderState, OrderStates } from './types';

const initialState: OrderState = {
  state: OrderStates.IDLE,
};

const orderSlice = createSlice({
  name: 'order',
  initialState,
  reducers: {
    selectProduct: (state, action: PayloadAction<Product>) => {
      state.selectedProduct = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createOrderActionCreator.pending, (state) => {
      state.state = OrderStates.START;
    });
    builder.addCase(createOrderActionCreator.fulfilled, (state, action) => {
      state.state = OrderStates.DONE;
      state.confirmation = action.payload;
    });
    builder.addCase(createOrderActionCreator.rejected, (state) => {
      state.state = OrderStates.ABORT;
    });
  },
});

export const {
  actions: { selectProduct },
  reducer: orderSliceReducer,
} = orderSlice;
